import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { LOGOUT } from '../../features/actions/Is-Logged-Actions';
import { connect } from 'react-redux';

import Container from 'react-bootstrap/Container';
//import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
//import Button from 'react-bootstrap/Button';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
//import Modal from 'react-bootstrap/Modal';
import Navbar from '../../components/Navbar';
import {
    Box,
    Button,
    FileInput,
    Grid,
    LoadingOverlay,
    Modal,
    NumberInput,
    Paper,
    Table,
    Tabs,
    Text,
    Textarea,
    TextInput,
    Tooltip,
    Select,
    Switch,
    Stack,
} from '@mantine/core';

import {
    DateInput,
    DatePickerInput,
    DateTimePicker
} from '@mantine/dates';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { IconEdit, IconPlus, IconX } from "@tabler/icons-react";

import HardwareAssetDataService from '../../services/hardware-asset-activities';

import authorizedDomainsForTenantChange from '../../authorized-domains-for-tenant-change';

//import { UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE } from '../../features/actions/Hardware-Asset-Filter-Actions';
//import { Table } from 'react-bootstrap';

class CreateHardwareOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status_selected: "Pending",
            placement_date: "",             // will be today's date by default - progroup can change
            selected_customer_id: 0,        // will automatically be the user's tenant if they are not progroup
            selected_customer_name: "",
            po_number: "",
            quote_number: "",
            order_name: "",
            comments: "",
            attachments: [],

            selected_form_tab: "Basic Info",


            product_name_entered: "",
            product_manufacturer_name_selected: "None",
            product_manufacturer_id_selected: 0,
            product_number_entered: "",
            product_qty_entered: 1,

            products_in_order: [                // items get generated when user inputs a product name and qty
                // {name: "Lenovo Thinkpad", manufacturer_name: "Lenovo", manufacturer_id: 1, product_number: "1234"},
                // {name: "Lenovo Thinkpad"}, 
                // {name: "Cisco Server"},
            ],

            products_to_qty: [      // calculated in this page to display in the products section of the order form

            ],

            manufacturers: [],
            tenants: [],

            show_customer_modal: false,
            showSaving: false,

            show_edit_product_modal: false,
            original_product_name: "",      // the "original" values are what existed before the edit started - used to target entries in products array
            original_man_name: "",
            original_man_id: 0,
            original_product_number: "",
            original_product_qty: 1,

            new_product_name: "",   // the "new" values are ones that the user approved in the edit form
            new_man_name: "",
            new_man_id: 0,
            new_product_number: "",
            new_product_qty: 1,


            authorizedDomainsForTenantChange: authorizedDomainsForTenantChange /* [
                "prorepro.com", "progroupco.com", "progroupco.org"
            ] */
        }
    }


    // converts the products in order array to an array of matching product names to quantities
    calculateProductQty(product_list) {
        const qtyResult = Object.values(
            product_list.reduce((acc, { name, manufacturer_name, manufacturer_id, product_number }) => {
                // Create a unique key based on all three fields
                const key = `${name.toLowerCase()}|${manufacturer_id ?? ""}|${(product_number || "").toLowerCase()}`;
            if (!acc[key]) {
                acc[key] = { name, qty: 0, manufacturer_name, manufacturer_id, product_number };
            }
            acc[key].qty += 1;
            return acc;
            }, {})
        );

        // Sort alphabetically by name (case-insensitive)
        qtyResult.sort((a, b) => 
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );

        console.log("Here is the qtyResult: ", qtyResult);

        this.setState({
            products_to_qty: qtyResult
        });
    }


    // updates the products_in_order and recacluates qtys for display in products table
    // updateOrderProducts(product_name, qty) {

    //     let newList = []

    //     for(let i = 0; i < qty; i++) {
    //         newList.push({name: product_name});
    //     }

    //     let comboList = [...this.state.products_in_order, ...newList];

    //     this.calculateProductQty(comboList);
    // }

    updateOrderProducts(product_name, man_id, man_name, product_number, qty) {
        // Filter out any existing entries of those product values
        // const filteredList = this.state.products_in_order.filter(
        //     (product) => product.name.toLowerCase() !== product_name.toLowerCase()
        // );
        console.log("Original products in order: ", this.state.products_in_order);

        const filteredList = this.state.products_in_order.filter((product) => {
            const nameMatches =
              product.name.toLowerCase() === product_name.toLowerCase();
            const manMatches =
              String(product.manufacturer_id) === String(man_id);
            const numberMatches =
              product.product_number.toLowerCase() ===
              product_number.toLowerCase();
          
            // Keep only those that DON'T match all three
            return !(nameMatches && manMatches && numberMatches);
        });

        console.log("Filtered products in order: ", filteredList);
    
        // Create a new array with the correct number of entries for this product
        const updatedProducts = [];
        for (let i = 0; i < qty; i++) {
            updatedProducts.push({ name: product_name, manufacturer_name: man_name, manufacturer_id: man_id, product_number: product_number });
        }
    
        // Combine the remaining items + the updated product group
        const comboList = [...filteredList, ...updatedProducts];
    
        // Recalculate quantities
        this.calculateProductQty(comboList);
    
        // Save to state
        this.setState({
            products_in_order: comboList,
            product_name_entered: "",
            product_number_entered: "",
            product_qty_entered: 1,
            //product_manufacturer_id_selected: 0,
            //product_manufacturer_name_selected: "None"
        });
    }

    deleteProductFromOrder(product_name) {
        // Filter out any existing entries of that product name
        const filteredList = this.state.products_in_order.filter(
            (product) => product.name.toLowerCase() !== product_name.toLowerCase()
        );

        this.calculateProductQty(filteredList);

        this.setState({
            products_in_order: filteredList
        });
    }

    // gets list of manufacturers for the add hardware asset drop down menu
    getManufacturers(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getManufacturers(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    //console.log("manufacturer response: ", response);
                    resolve(response.data.results);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of tenant names this tech is authorized to see for the filter drop down menu
    getTenantList(asker_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getTenants(asker_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    //console.log("tenant list response: ", response);
                    resolve(response.data.results);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }


    componentDidMount() {
        if (this.props.loggedStatus.loggedIn) {
            

            // const tenantList = this.getTenantList(this.props.loggedStatus.id);
            this.getTenantList(this.props.loggedStatus.id).then(tenantList => {

            let tenantIdToUse;

            if(this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase())) {
                // if they are authorized, allow them to add to the tenant that was selected on the other screen
                tenantIdToUse = this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId;
            }

            else {
                // they are unauthorized tenant, so use this user's own tenant info instead
                tenantIdToUse = this.props.loggedStatus.primary_tenant_id;
            }

            let tenantNameSelected = tenantList.find((e) => e.id === tenantIdToUse).name_of_tenant;

            this.setState({
                tenants: tenantList,
                selected_customer_id: tenantIdToUse,
                selected_customer_name: tenantNameSelected
            });

            // get manufactrers for the drop down
            // const manufacturerList = this.getManufacturers();
            this.getManufacturers(tenantIdToUse).then(manufacturerList => {
                this.setState({
                    manufacturers: [{id: 0, name_of_manufacturer: "None"}, ...manufacturerList]
                });
            })

            // Set the placement date to today by default
            // Get current date
            const now = new Date();

            // Convert to UTC midnight (00:00:00 GMT)
            // const utcDate = new Date(Date.UTC(
            //     now.getUTCFullYear(),
            //     now.getUTCMonth(),
            //     now.getUTCDate(),
            //     0, 0, 0, 0
            // ));
            
            //const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            
            //const todayStr = new Date().toLocaleDateString('en-CA'); // "2025-11-12"

            this.setState({
                placement_date: now
            });

            // if you're on edit page, you'd get the list of products for this order here!

            //this.calculateProductQty(this.state.products_in_order);     // turn off in final
        })
        }
    }

    openCustomerModal() {
        this.setState({
            show_customer_modal: true
        });
    }

    closeCustomerModal() {
        this.setState({
            show_customer_modal: false
        });
    }

    openEditProductModal(name, manufacturer_name, product_number, qty) {

        var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === manufacturer_name).id;

        this.setState({
            show_edit_product_modal: true,
            original_product_name: name,      // the "original" values are what existed before the edit started - used to target entries in products array
            original_man_name: manufacturer_name,
            original_man_id: manId,
            original_product_number: product_number,
            original_product_qty: qty,

            new_product_name: name,   // the "new" values are ones that the user approved in the edit form
            new_man_name: manufacturer_name,
            new_man_id: manId,
            new_product_number: product_number,
            new_product_qty: qty,
        });;
    }

    closeEditProductModal() {
        this.setState({
            show_edit_product_modal: false,
            original_product_name: "",      // the "original" values are what existed before the edit started - used to target entries in products array
            original_man_name: "",
            original_man_id: 0,
            original_product_number: "",
            original_product_qty: 1,

            new_product_name: "",   // the "new" values are ones that the user approved in the edit form
            new_man_name: "",
            new_man_id: 0,
            new_product_number: "",
            new_product_qty: 1,
        });
    }

    handleEditProductNameChange(newValue) {
        this.setState({
            new_product_name: newValue
        });
    }

    handleEditProductManufacturerChange(newName, newId) {
        this.setState({
            new_man_id: newId,
            new_man_name: newName
        });
    }

    handleEditProductNumberChange(newValue) {
        this.setState({
            new_product_number: newValue
        });
    }

    handleEditProductQtyChange(newValue) {
        this.setState({
            new_product_qty: newValue
        });
    }

    // this will filter out the entry in products in order that had the original values and replace them with the new ones entered
    editOrderProducts(new_product_name, new_man_id, new_man_name, new_product_number, new_product_qty) {
        // Filter out any existing entries of those product values
        // const filteredList = this.state.products_in_order.filter(
        //     (product) => product.name.toLowerCase() !== this.state.original_product_name.toLowerCase()
        // );
        const filteredList = this.state.products_in_order.filter((product) => {
            const nameMatches =
              product.name.toLowerCase() === this.state.original_product_name.toLowerCase();
            const manMatches =
              String(product.manufacturer_id) === String(this.state.original_man_id);
            const numberMatches =
              product.product_number.toLowerCase() ===
              this.state.original_product_number.toLowerCase();
          
            // Keep only those that DON'T match all three
            return !(nameMatches && manMatches && numberMatches);
        });
    
        // Create a new array with the correct number of entries for this product
        const updatedProducts = [];
        for (let i = 0; i < new_product_qty; i++) {
            updatedProducts.push({ name: new_product_name, manufacturer_name: new_man_name, manufacturer_id: new_man_id, product_number: new_product_number });
        }
    
        // Combine the remaining items + the updated product group
        const comboList = [...filteredList, ...updatedProducts];
    
        // Recalculate quantities
        this.calculateProductQty(comboList);
    
        // Save to state
        this.setState({
            products_in_order: comboList
        }, () => {
            this.closeEditProductModal();
        });
    }


    handleCustomerChange(newCustomerId, newCustomerName) {
        
        this.setState({
            selected_customer_id: newCustomerId,
            selected_customer_name: newCustomerName
        });
    }

    handleNewProductNameChange(newName) {
        this.setState({
            product_name_entered: newName
        });
    }

    handleNewProductQtyChange(newQty) {
        this.setState({
            product_qty_entered: newQty
        });
    }

    handleNewProductManufacturerChange(newName, newId) {
        this.setState({
            product_manufacturer_id_selected: newId,
            product_manufacturer_name_selected: newName
        });
    }

    handleNewProductNumberChange(newValue) {
        this.setState({
            product_number_entered: newValue
        });
    }

    handleStatusChange(newValue) {
        this.setState({
            status_selected: newValue
        });
    }


    handlePlacementDateChange(date) {
        //console.log(date);
        this.setState({
            placement_date: date
        });
    }

    handlePONumberChange(newValue) {
        this.setState({
            po_number: newValue
        });
    }

    handleQuoteNumberChange(newValue) {
        this.setState({
            quote_number: newValue
        });
    }

    handleOrderNameChange(newValue) {
        this.setState({
            order_name: newValue
        });
    }

    handleCommentsChange(newValue) {
        this.setState({
            comments: newValue
        });
    }


    handleAttachmentUploadChange = (files) => {
        if (!files) {
          // Clear state when user clears selection
          this.setState({ attachments: [] });
          return;
        }
      
        // Ensure files is always an array
        const fileArray = Array.isArray(files) ? files : [files];
      
        // Optional: validate file types and size
        const validFiles = fileArray.filter((file) => {
          const maxSizeMB = 50;
          const allowedTypes = [
            "image/jpeg", "image/png", "image/bmp", "image/heic",
            "application/pdf", "application/msword", 
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/octet-stream", // sometimes .dwg or .txt files come in as this
            "text/plain"
          ];
      
          const isValidType = allowedTypes.includes(file.type);
          const isValidSize = file.size <= maxSizeMB * 1024 * 1024;
      
          if (!isValidType) {
            console.log(`Rejected file: ${file.name} — unsupported type (${file.type})`);
          }
          if (!isValidSize) {
            console.log(`Rejected file: ${file.name} — exceeds ${maxSizeMB}MB`);
          }
      
          return isValidType && isValidSize;
        });
      
        // Store in component state (you can upload later when the form submits)
        this.setState({ attachments: validFiles });
    };


    handleFormSubmit = async (event) => {
        event.preventDefault();

        this.setState({
            showSaving: true
        });
      
        const { attachments } = this.state;
        if (!attachments || attachments.length === 0) {
          console.log("No files to upload");
          //return;
        }
      
        // Create a FormData object
        const formData = new FormData();
      
        // Append each file (use same key if backend expects array)
        attachments.forEach((file, index) => {
          formData.append("attachments[]", file); // "attachments[]" is common for arrays
        });


        formData.append("status_selected", this.state.status_selected);
        formData.append("placement_date", this.state.placement_date.toISOString().split('T')[0]);       
        formData.append("selected_customer_id", this.state.selected_customer_id);
        formData.append("selected_customer_name", this.state.selected_customer_name);
        formData.append("po_number", this.state.po_number);
        formData.append("quote_number", this.state.quote_number);
        formData.append("order_name", this.state.order_name);
        formData.append("comments", this.state.comments);

        formData.append("products_in_order", JSON.stringify(this.state.products_in_order));
        formData.append("products_to_qty", JSON.stringify(this.state.products_to_qty));

        // Log all key-value pairs
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        HardwareAssetDataService.createHardwareOrder(formData).then(response => {
            console.log(response);

            this.goBackToPreviousPage();
        })
        .catch(e => {
            console.log(e);
        });

      
      
        // try {
        //   const response = await fetch("/api/upload", {
        //     method: "POST",
        //     body: formData,
        //     // Note: Do NOT set 'Content-Type' to multipart/form-data manually.
        //     // The browser will set the correct boundary automatically.
        //   });
      
        //   if (!response.ok) {
        //     throw new Error(`Upload failed: ${response.statusText}`);
        //   }
      
        //   const result = await response.json();
        //   console.log("Upload successful:", result);
        // } catch (error) {
        //   console.error("Error uploading files:", error);
        // }
    };

    goBackToPreviousPage() {
        this.props.history.push(`/hardwareAssets`);
    }

    render() {
        if (!this.props.loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
        }

        return (
            <>
                <Navbar pageTitle={"Create Hardware Order"} />
                <div style={{ paddingTop: "15px" }} />
                <Container fluid pt="20px" >
                    <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                        <Grid>
                            <Grid.Col span={6}>
                                <Table withRowBorders={false} style={{cursor: "default"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Customer</Table.Td>
                                        <Table.Td c="blue">{this.state.selected_customer_name}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Grid.Col>
                            <Grid.Col span={6} align="right">
                                <div style={{position: "relative"}}>
                                    {/* <span style={{position: "absolute", right: "100px", top: "10px"}}><Checkbox 
                                        label="Disable Notifications"
                                        //description="Determines if this item will appear in the notification center when cutoff dates approach"
                                        //style={{marginTop: "32px"}}
                                        checked={this.state.is_resolved}
                                        onChange={() => this.handleIsResolvedChange()}
                                    />
                                    </span> */}
                                    {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                        <span><Button onClick={() => this.openCustomerModal()}><IconEdit/></Button></span>
                                        :
                                        undefined
                                    }
                                </div>
                            </Grid.Col>
                        </Grid>
                    </Paper>
                    <div style={{marginTop: "25px"}}></div>
                    <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block" style={{height: "550px"}}>
                        <Tabs radius="md" defaultValue="Basic Info">
                            <Tabs.List>
                                <Tabs.Tab value="Basic Info" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}>Basic Info</Tabs.Tab>
                                <Tabs.Tab value="Products" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}>Products</Tabs.Tab>
                            </Tabs.List>
                            <Tabs.Panel value="Basic Info">
                                <div style={{marginTop: "30px"}}></div>
                                <form onSubmit={this.handleFormSubmit}>
                                    <Stack gap="md">
                                        <Grid>
                                            <Grid.Col span={6}>
                                                {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                                    <Select 
                                                        label="Status"
                                                        value={this.state.status_selected}
                                                        data={["Pending", "Open", "Completed", "Cancelled"]}
                                                        onChange={(s) => this.handleStatusChange(s)}
                                                        allowDeselect={false}
                                                    />
                                                    :
                                                    <Select 
                                                        label="Status"
                                                        value={this.state.status_selected}
                                                        data={["Pending", "Open", "Completed", "Cancelled"]}
                                                        disabled
                                                    />
                                                }
                                            </Grid.Col>
                                            <Grid.Col span={6}>
                                                {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                                    <DateInput 
                                                        label="Placement Date"
                                                        value={this.state.placement_date}
                                                        onChange={(e) => this.handlePlacementDateChange(e)}
                                                    />
                                                    :
                                                    <DateInput 
                                                        label="Placement Date"
                                                        value={this.state.placement_date}
                                                        disabled
                                                    />
                                                }
                                            </Grid.Col>
                                        </Grid>
                                        <Grid>
                                            <Grid.Col span={6}>
                                                <TextInput 
                                                    label="PO #"
                                                    value={this.state.po_number}
                                                    onChange={(e) => this.handlePONumberChange(e.target.value)}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={6}>
                                                <TextInput 
                                                    label="Quote #"
                                                    value={this.state.quote_number}
                                                    onChange={(e) => this.handleQuoteNumberChange(e.target.value)}
                                                />
                                            </Grid.Col>
                                        </Grid>
                                        <TextInput 
                                            label="Order Name"
                                            value={this.state.order_name}
                                            onChange={(e) => this.handleOrderNameChange(e.target.value)}
                                        />
                                        <Textarea 
                                            label="Comments"
                                            value={this.state.comments}
                                            onChange={(e) => this.handleCommentsChange(e.target.value)}
                                        />
                                        <FileInput 
                                            label="Upload Attachments"
                                            placeholder="Click to upload"
                                            description="(optional - must be .jpg, .jpeg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, or .txt and less than 50MB)"
                                            accept=".jpeg, .jpg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, .txt"
                                            multiple
                                            clearable
                                            onChange={(e) => this.handleAttachmentUploadChange(e)}
                                        />
                                    </Stack>
                                </form>
                            </Tabs.Panel>
                            <Tabs.Panel value="Products">
                                <div style={{marginTop: "30px"}}></div>
                                <>
                                    <form>
                                        <Grid align="end">
                                            <Grid.Col span={4}>
                                                <TextInput 
                                                    label="Product Name"
                                                    value={this.state.product_name_entered}
                                                    onChange={(e) => this.handleNewProductNameChange(e.target.value)}
                                                    required
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={3}>
                                                <Select 
                                                    label="Manufacturer"
                                                    value={this.state.product_manufacturer_name_selected}
                                                    data={
                                                        this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                                            manufacturer.name_of_manufacturer
                                                        ))
                                                    }
                                                    onChange={(s) => {
                                                            var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                                            if(manId !== null) {
                                                                this.handleNewProductManufacturerChange(s, manId);
                                                            }
                                                        }
                                                    }
                                                    searchable
                                                    allowDeselect={false}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={2}>
                                                <TextInput
                                                    label="Product Number"
                                                    value={this.state.product_number_entered}
                                                    onChange={(e) => this.handleNewProductNumberChange(e.target.value)}
                                                    />
                                            </Grid.Col>
                                            <Grid.Col span={2}>
                                                <NumberInput 
                                                    label="Quantity"
                                                    min={1}
                                                    allowNegative={false}
                                                    allowDecimal={false}
                                                    value={this.state.product_qty_entered}
                                                    onChange={(e) => this.handleNewProductQtyChange(e)}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={1}>
                                                {this.state.product_name_entered !== "" ?
                                                    <Button style={{marginLeft: "15px"}} onClick={() => this.updateOrderProducts(this.state.product_name_entered, this.state.product_manufacturer_id_selected, this.state.product_manufacturer_name_selected, this.state.product_number_entered, this.state.product_qty_entered)}>Add</Button>
                                                    :
                                                    <Button style={{marginLeft: "15px"}} disabled>Add</Button>
                                                }
                                            </Grid.Col>
                                        </Grid>
                                    </form>
                                    <div style={{marginTop: "25px"}}>
                                        <Table miw={700}>
                                            <Table.Thead>
                                                <Table.Tr>
                                                    <Table.Th w={"35%"}>Product</Table.Th>
                                                    <Table.Th w={"20%"}>Manufacturer</Table.Th>
                                                    <Table.Th w={"20%"}>Product Number</Table.Th>
                                                    <Table.Th w={"15%"}>Quantity</Table.Th>
                                                </Table.Tr>
                                            </Table.Thead>
                                            <Table.Tbody>
                                                {this.state.products_to_qty && this.state.products_to_qty.map((product) => (
                                                    <Table.Tr>
                                                        <Table.Td>{product.name}</Table.Td>
                                                        <Table.Td>{product.manufacturer_name}</Table.Td>
                                                        <Table.Td>{product.product_number}</Table.Td>
                                                        <Table.Td style={{display: "flex", justifyContent: 'space-between', alignItems: "center"}}>
                                                            <span>{product.qty}</span>
                                                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                <IconEdit style={{cursor: "pointer"}} onClick={() => this.openEditProductModal(product.name, product.manufacturer_name, product.product_number, product.qty)} />
                                                                <IconX style={{color: "red", cursor: "pointer"}} onClick={() => this.deleteProductFromOrder(product.name)} />
                                                            </div>
                                                        </Table.Td>
                                                        {/* <Table.Td style={{display: "flex", justifyContent: 'space-between', alignItems: "center"}}>{product.qty}<IconX style={{color: "red", cursor: "pointer"}} onClick={() => this.deleteProductFromOrder(product.name)} /></Table.Td> */}
                                                    </Table.Tr>
                                                ))}
                                            </Table.Tbody>
                                        </Table>
                                    </div>
                                </>
                                    
                            </Tabs.Panel>
                        </Tabs>
                    </Paper>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeOrderFormError ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "25px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.goBackToPreviousPage()}>Cancel</Button></span>
                        <span><Button onClick={this.handleFormSubmit}>Submit</Button></span>
                    </div>
                </Container>

                <Modal
                    opened={this.state.show_customer_modal}
                    onClose={() => this.closeCustomerModal()}
                    //title="Let's Start With the Following Data"
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Select Customer</Text></div>
                        {/* THE HIDDEN ELEMENT WAS NEEDED AT THE TOP OF THE FORM TO ALLOW THE FIRST ELEMENT TO BE SEARCHABLE - WAS CAUSING ERROR OTHERWISE */}
                        <Form.Group as={Col} controlId="hiddenElementCustomerModal"><TextInput hidden></TextInput></Form.Group>
                        <Form.Group as={Col} controlId="createContractCustomer">
                            <Select 
                                label="What company does this order belong to?"
                                placeholder="Pick a Value"
                                data={this.state.tenants && this.state.tenants.map((tenant) => (
                                    tenant.name_of_tenant
                                ))}
                                value={
                                    this.state.selected_customer_id  !== 0 && this.state.tenants && this.state.tenants.length > 0 && this.state.tenants.find((e) => e.id === this.state.selected_customer_id) ? 
                                        this.state.tenants.find((e) => e.id === this.state.selected_customer_id).name_of_tenant
                                        :
                                        ""
                                }
                                onChange={(s) => {
                                    var customerId = this.state.tenants.find((e) => e.name_of_tenant === s).id;
                                    if(customerId !== null) {
                                        this.handleCustomerChange(customerId, s);
                                    }
                                }}
                                allowDeselect={false}
                                searchable
                            />
                        </Form.Group>
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span><Button onClick={() => this.closeCustomerModal()}>Ok</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for the loading screen */}
                <Modal
                    opened={this.state.showSaving}
                    onClose={() => { this.setState({ showSaving: false }) }}
                    size="xl"
                    centered
                    withCloseButton={false}
                >


                    <Modal.Body>
                        <div className="gothamNarrowLightFont" style={{ cursor: "default", textAlign: "center" }}>Saving... Please wait.</div>
                    </Modal.Body>

                </Modal>

                {/* This modal is for the edit product in order form */}
                <Modal
                    opened={this.state.show_edit_product_modal}
                    onClose={() => this.closeEditProductModal()}
                    title="Edit Product Entry"
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <form>
                        <Grid>
                            <Grid.Col span={6}>
                                <TextInput 
                                    label="Product Name"
                                    value={this.state.new_product_name}
                                    onChange={(e) => this.handleEditProductNameChange(e.target.value)}
                                    required
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Select 
                                    label="Manufacturer"
                                    value={this.state.new_man_name}
                                    data={
                                        this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                            manufacturer.name_of_manufacturer
                                        ))
                                    }
                                    onChange={(s) => {
                                            var manId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                            if(manId !== null) {
                                                this.handleEditProductManufacturerChange(s, manId);
                                            }
                                        }
                                    }
                                    searchable
                                />
                            </Grid.Col>
                        </Grid>
                        <Grid>
                            <Grid.Col span={6}>
                                <TextInput
                                    label="Product Number"
                                    value={this.state.new_product_number}
                                    onChange={(e) => this.handleEditProductNumberChange(e.target.value)}
                                    />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <NumberInput 
                                    label="Quantity"
                                    min={1}
                                    allowNegative={false}
                                    allowDecimal={false}
                                    value={this.state.new_product_qty}
                                    onChange={(e) => this.handleEditProductQtyChange(e)}
                                />
                            </Grid.Col>
                        </Grid>
                    </form>
                    <div style={{textAlign: 'center', marginTop: "25px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeEditProductModal()}>Cancel</Button></span>
                        <span>
                            {this.state.new_product_name !== "" ? 
                                <Button onClick={() => this.editOrderProducts(this.state.new_product_name, this.state.new_man_id, this.state.new_man_name, this.state.new_product_number, this.state.new_product_qty)}>Update</Button>
                                :
                                <Button disabled>Update</Button>
                            }
                        </span>
                    </div>
                </Modal>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions,
        hardwareAssetFilter: state.hardwareAssetFilter
    };
}

export default connect(mapStateToProps, { LOGOUT })(CreateHardwareOrder);